module.exports = __webpack_public_path__ + "img/logo_wirtschaftsregion_passau.8ac84a1.svg";